import CryptoES from 'crypto-es';

const createKey = (s) => {
  return CryptoES.SHA3(s, { outputLength: 32 }).toString()
}

export default createKey


// WEBPACK FOOTER //
// ./src/views/tools/createKey.js